<template>
    <div class="app-container">

        <el-form :model="queryParams" ref="queryForm"  :inline="true" v-show="showSearch" style='width: 100%'>
            <el-form-item label="类型" prop="status">
                <el-select v-model="queryParams.type" placeholder="请选择" clearable>

                    <el-option clearable v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>

            </el-form-item>
            <el-form-item style='float: right;'>
              <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>


        <el-table :data="locationList" id="excel"
            @selection-change="handleSelectionChange" v-loading="listloading" border style="width: 100%">
            <el-table-column type="selection" width="40">
      </el-table-column>

      <el-table-column prop="type" label="问题方面" width="100">

</el-table-column>
            <el-table-column label="留言内容 " prop='content' :show-overflow-tooltip="true">

            </el-table-column>

            <el-table-column prop="username" label="用户姓名" width='100' :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="userphone" label="用户电话" width='120'>
            </el-table-column>
          <el-table-column label="所属街镇" prop='region' width='100'>

          </el-table-column>
            <el-table-column prop="createtime" label="留言时间" :show-overflow-tooltip="true">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>

        </el-table>
<!--        <div class="block" style="margin-top:20px;">
            <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[5, 10, 15, 20, 30, 45, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>-->
         <pagination v-show='total > 0' :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.pagesize"
            @pagination="fetchList" />
    </div>
</template>

<script>
import { boardlist, boarddelete } from "../api/list"
import { export2Excel } from '../utils/export2Excel'
export default {
  data() {
    return {
          lb:'',
            showSearch: true,
            queryParams: {
                type: '',
                keyword: '',
                page: 1,
                pagesize: 15
            },
            total:0,
            currentPage: 1, // 当前页码
            // 总条数
            pageSize: 10,// 每页的数据条数
            locationList: [],
            multipleSelection:[],
            listloading: false,
            options: [{
                value: '教育质量',
                label: '教育质量'
            }, {
                value: '医疗卫生',
                label: '医疗卫生'
            }, {
                value: '城乡环境',
                label: '城乡环境'
            }, {
                value: '社会治安',
                label: '社会治安'
            }, {
                value: '文体生活',
                label: '文体生活'
            },
            {
                value: '社会保障',
                label: '社会保障'
            }
            ],
            value: '',
            tableTitleData: [
        {
                title: '问题方面',
                key: 'type'
              },
        {
          title: '留言内容',
          key: 'content'
        },
              {
                title: "用户姓名",
                key: "username"
              }
              ,
              {
                title: "用户电话",
                key: "userphone"
              },
        {
          title: "所属街镇",
          key: "region"
        },
        {
          title: "留言时间",
          key: "createtime"
        }
      ],
        }
    },
    created() {
        this.fetchList();
    },
    methods: {
        exportExcel() {


            if (this.multipleSelection.length < 1) {
                this.$message('请选择需要导出的列表');
            } else {
              this.lb = '留言列表' + this.queryParams.type;
                export2Excel(this.tableTitleData, this.multipleSelection,this.lb)
            }
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },


        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.currentPage = 1;
            this.pageSize = val;
        },
        //当前页改变时触发 跳转其他页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
        },
        fetchList() {
            this.listloading = true

            boardlist(this.queryParams).then(res => {
              this.locationList = res.data
              this.total = res.pageInfo.total
              this.queryParams.page = res.pageInfo.page;
              this.pages = res.pageInfo.pages;
              this.listloading = false
            })
        },
        handleDelete(index, row) {
            boarddelete({ id: row.id }).then(res => {
                this.$notify({
                    title: '成功',
                    message: '删除成功',
                    type: 'success',
                    duration: 2000
                })
                this.locationList.splice(index, 1)
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        handleQuery() {
          this.queryParams.page = 1;
            this.fetchList()
        },
        resetQuery() {
            this.queryParams.keyword = undefined
            this.handleQuery();
        },
    }
}
</script>

<style lang="scss" scoped></style>
